import { Order }   from "../planner_base";
import watch from "redux-watch";
import isEqual from 'is-equal';
import { LineOverOrdersPhase } from './model';
import {
  PLANNER_OVER_ORDERS_PHASE,
  PLANNER_OUT_ORDERS_PHASE,
  PLANNER_CLICK_UNDER,
  PLANNER_CLICK_STATUS,
  PLANNER_CLICK_PIN
} from 'apps/events';
class Props extends Order {
  // isIncluded: boolean = false;
  init(){
    super.init()
    this.initPin()
    this.watch()
  }
  initPin(){
    if(!this.opts.usePin) {return;};
    let data = App.store.getState().data
    let items = data['forms_planner_search'].inputs.order_ids.items
    for(let i=0;i<items.length;i++){
      if(this.opts.id.toString() == items[i].order_id.toString()){
        this.opts['pined'] = true;
        return;
      }
    }
  }
  phase_name(id){
    return this.getPhaseData(id).name.substr(0,1);
  }
  onOverOrdersPhase(e){
    let lineOverOrdersPhase = new LineOverOrdersPhase(e.item, e.target)
    let customEvent = new CustomEvent(PLANNER_OVER_ORDERS_PHASE, { detail: lineOverOrdersPhase });
    document.dispatchEvent(customEvent);
  }
  onOutOrdersPhase(e){
    let customEvent = new CustomEvent(PLANNER_OUT_ORDERS_PHASE);
    document.dispatchEvent(customEvent);
  }
  onMouseDownUnder(e){
    let detail = { opts: this.opts, element: e.target };
    let customEvent = new CustomEvent(PLANNER_CLICK_UNDER, { detail: detail });
    document.dispatchEvent(customEvent);
  }
  onMouseDownStatus(e){
    let detail = { opts: this.opts, element: e.target };
    let customEvent = new CustomEvent(PLANNER_CLICK_STATUS, { detail: detail });
    document.dispatchEvent(customEvent);
  }
  togglePin(){
    let customEvent = new CustomEvent(PLANNER_CLICK_PIN, { detail: this.opts.id })
    document.dispatchEvent(customEvent);
    // this.checkInclusion();
  }
  // checkInclusion(){
  //   let currentIds = this.getState().data['forms_planner_search'].inputs.order_ids.value
  //   if(!currentIds || currentIds == ''){ this.notIncluded(); return;}
  //   let ary = currentIds.split(',')
  //   let index = ary.indexOf(this.opts.id.toString())
  //   if(index >= 0){
  //     this.included();
  //   } else {
  //     this.notIncluded();
  //   }
  // }
  // notIncluded(){
  //   this.isIncluded = false
  //   this.update();
  // }
  // included(){
  //   this.isIncluded = true;
  //   this.update();
  // }
}
riot.mixin('orders.planner.props', Props as riot.TagMixin)
